// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: gateway KONVO_CHAT_SUGGESTIONS: the server looked at a chat as its messages arrived
// (konvo_api KonvoChatArrival) and sends the chat's suggestions: {chat_key, analysed_id,
// suggestions, people}. Merged like the app's own look (AssistantSuggestions.applyPush).

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import AssistantSuggestions, {
	type StoredChatSuggestions,
} from '@app/features/konvo_assistant/state/AssistantSuggestions';

const CHAT_KEY = /^(\d{1,30}|whatsapp:[A-Za-z0-9:_@.-]{1,120})$/;

export function handleKonvoChatSuggestions(data: unknown, _context: GatewayHandlerContext): void {
	if (!data || typeof data !== 'object') return;
	const event = data as Partial<StoredChatSuggestions>;
	if (typeof event.chat_key !== 'string' || !CHAT_KEY.test(event.chat_key)) return;
	if (typeof event.analysed_id !== 'string' || !Array.isArray(event.suggestions)) return;
	AssistantSuggestions.applyPush({
		chat_key: event.chat_key,
		analysed_id: event.analysed_id,
		suggestions: event.suggestions,
		people: Array.isArray(event.people) ? event.people : [],
	});
}
